exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.parent[data-v-720f9d65] {\n  display: grid;\n  grid-template-columns: repeat(6, 1fr);\n  grid-template-rows: repeat(5, 1fr);\n  gap: 8px;\n}\n.div1[data-v-720f9d65] {\n  grid-column: span 3 / span 3;\n  grid-row: span 5 / span 5;\n}\n.div2[data-v-720f9d65] {\n  grid-column: span 3 / span 3;\n  grid-row: span 4 / span 4;\n  grid-column-start: 4;\n}\n.div3[data-v-720f9d65] {\n  grid-column: span 3 / span 3;\n  grid-column-start: 4;\n  grid-row-start: 5;\n}\n", ""]);

// exports
